import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CustomizerService } from 'src/app/services/customizer.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  constructor(public customizer: CustomizerService,
    private authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  redirect() {
    if (this.authService.isCustomer()) {
      return
    } else {
      this.router.navigate(['/dashboards/dashboard1'])
    }
  }

}
